'use strict';

module.exports = require('./is-implemented')()
	? Object.assign
	: require('./shim');



/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/motion/js-deps/~/es5-ext/object/assign/index.js
 ** module id = 63
 ** module chunks = 2
 **/